import { render } from "./PhotoGalleryHOF.vue?vue&type=template&id=077e2915&scoped=true"
import script from "./PhotoGalleryHOF.vue?vue&type=script&lang=js"
export * from "./PhotoGalleryHOF.vue?vue&type=script&lang=js"

import "./PhotoGalleryHOF.vue?vue&type=style&index=0&id=077e2915&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jgurl\\KontraWebsite\\KontraSports\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-077e2915"]])

export default __exports__